import styled from "@emotion/styled";

import { DesignToken, ShadowToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IProps {
  backgroundColor?: string;
  arrowPosition?: "left" | "right" | "top" | "bottom";
  arrowOffset?: number;
}

export const DarkTooltip = styled.div<IProps>`
  padding: 11px 12px;
  color: ${withVar(DesignToken.ContentInvertPrimary)};
  font-size: 14px;
  border-radius: 4px;
  background-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.backgroundColor || withVar(DesignToken.BorderBasicContrast)
  };
  box-shadow: ${withVar(ShadowToken.Tooltip)};
  margin: 4px;

  &::before {
    content: " ";
    position: absolute;
    border-width: 4px;
    border-style: solid;

    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => {
        if (props.arrowOffset) {
          return `
          top: ${props.arrowOffset}px;
        `;
        }
        return `
        top: 50%;
        transform: translateY(-50%);
      `;
      }
    };

    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => {
        switch (props.arrowPosition) {
          case "left":
            return `
            border-color: transparent ${
              props.backgroundColor || withVar(DesignToken.BorderBasicContrast)
            } transparent transparent;
            left: -4px;
          `;
          case "right":
            return `
            border-color: transparent transparent transparent ${
              props.backgroundColor || withVar(DesignToken.BorderBasicContrast)
            };
            right: -4px;
          `;
          case "top":
            return `
            border-color: transparent transparent ${
              props.backgroundColor || withVar(DesignToken.BorderBasicContrast)
            } transparent;
            top: -4px;
            left: calc(50% - 4px);
          `;
          case "bottom":
            return `
            top: unset;
            border-color: ${
              props.backgroundColor || withVar(DesignToken.BorderBasicContrast)
            } transparent transparent transparent;
            bottom: -12px;
            left: calc(50% - 4px);
          `;
          // no default
        }
        return "";
      }
    };
  }
`;

DarkTooltip.defaultProps = {
  arrowPosition: "left",
};
